import React, { useEffect } from 'react';
import { useLocation } from '../../context/LocationContext';
import MenuItem from '@mui/material/MenuItem';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { tokens } from '../../theme';

export default function UserLocation({ locationOptns, change }) {
    const usrLocs = localStorage.getItem('usrlctn')
    const { selectedLocation, setSelectedLocation } = useLocation();
    const locCount = locationOptns.length

    useEffect(() => {
        change()
    }, [selectedLocation])

    const handleChange = ({ target }) => {
        const value = target.value
        setSelectedLocation(value)
    }

    const fieldSx = {
        minWidth: { xs: 140, sm: 200 },
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            backgroundColor: tokens.surface,
            fontSize: 14,
            '& fieldset': { borderColor: tokens.border },
            '&:hover fieldset': { borderColor: tokens.brown },
            '&.Mui-focused fieldset': { borderColor: tokens.accent },
        },
    };

    return (
        <>
            {(locCount > 1) ?
                <>
                    <TextField
                        select
                        size='small'
                        onChange={(e) => handleChange(e)}
                        value={usrLocs}
                        sx={fieldSx}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PlaceOutlinedIcon sx={{ color: tokens.brown, fontSize: 18 }} />
                                </InputAdornment>
                            ),
                        }}
                    >
                        {locationOptns.map((loc, ind) => (
                            <MenuItem key={ind} value={loc}>
                                {loc}
                            </MenuItem>
                        ))}

                    </TextField>
                </>
                :

                <>
                    <TextField defaultValue={usrLocs}
                        size='small'
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PlaceOutlinedIcon sx={{ color: tokens.brown, fontSize: 18 }} />
                                </InputAdornment>
                            ),
                            readOnly: true
                        }}
                        sx={fieldSx}
                    />
                </>
            }
        </>
    );
};
